import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { removeNullFields } from "../../../../common/mapper";
import { INITIAL_PAGINATION } from "../../constant";
import { modalClaimMainTableConfig } from "./config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ModalClaim extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      searchValue: null,
      pagination: INITIAL_PAGINATION,
      detailTable: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;
    if (
      currPagination.page !== prevPagination.page ||
      currPagination.limit !== prevPagination.limit
    ) {
      this.fetchData(currPagination.limit, currPagination.page);
    }
  }

  fetchData = async (limit, page) => {
    const { onTriggerLoading, setError, formData } = this.props;
    const { searchValue } = this.state;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataClaimFjb,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: removeNullFields({
        kodeCabang: formData?.kodeCabang?.value,
        customerName: searchValue,
        claimType: formData?.tipeFjb?.value,
        limit: limit || 5,
        page: page || 1,
      }),
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  fetchClaimPart = async (id) => {
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getClaimPartByManagementId,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        claimManagementId: id,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        detailTable: res.data.data,
      }));
    }
  };

  handleSelectClaim = (value) => {
    const { onChangeData, onClickClose } = this.props;
    onChangeData("claimNo", value);
    onClickClose();
  };

  getMainTableConfig = () => {
    return modalClaimMainTableConfig({
      onSelect: this.handleSelectClaim,
      onShowDetail: this.fetchClaimPart,
    });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { dataTable, pagination, searchValue, detailTable } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="List Data Claim"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <div style={{ overflowX: "auto", }}>
                <FlexView vAlignContent="center">
                  <h4 className="txt-site txt-11 txt-main txt-bold margin-bottom-20px">
                    Nama Pemilik
                  </h4>
                  <SimpleInput
                    id="consumenName"
                    onChange={({ target }) => {
                      this.setState({
                        searchValue: target.value,
                      });
                    }}
                    value={searchValue}
                    placeholder="Nama Konsumen"
                    containerclassname="width width-250px margin-left-10px"
                  />
                  <SimpleButton
                    id="btn_consumen_name"
                    className="margin-bottom-20px"
                    text="Cari"
                    onClick={() => this.fetchData()}
                  />
                </FlexView>
                <FlexView style={{ gap: "20px" }}>
                  <div className="flex-1">
                    <SimpleDataTable
                      data={dataTable}
                      columns={this.getMainTableConfig()}
                      toCount={pagination.totalData}
                      rowsPerPage={pagination.limit}
                      page={pagination.page - 1}
                      options={defaultTableChange(
                        this.handleChangePage,
                        this.handleRowsPerPage
                      )}
                    />
                  </div>
                  <SimpleDataTable
                    data={detailTable}
                    containerclassname
                    columns={[
                      { label: "Kode Part", name: "kodePart" },
                      { label: "Nama Part", name: "namaPart" },
                    ]}
                    options={{ pagination: false }}
                  />
                </FlexView>
              </div>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default ModalClaim;
